/* eslint-disable default-param-last */
/* eslint-disable no-case-declarations */
import {
  CLEAR_LANDING_PAGE_FILTERS,
  STORE_FILTER_API_RESPONSES,
  UPDATE_LANDING_PAGE_FILTERS,
  UPDATE_SEARCH_VALUE,
} from '../actions/landingPageFiltersAction';

const initialState = {
  selectedFilters: {
    checkedPlatforms: [],
    checkedAssets: [],
    checkedRoles: [],
  },
  searchValue: '',
  apiResponses: {
    platformResponse: null,
    assetResponse: null,
    roleResponse: null,
  },
};

const landingPageFiltersReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_LANDING_PAGE_FILTERS:
      const { checkedPlatforms, checkedAssets, checkedRoles } = action.payload;

      return {
        ...state,
        selectedFilters: { checkedPlatforms, checkedAssets, checkedRoles },
      };
    case CLEAR_LANDING_PAGE_FILTERS:
      return {
        ...state,
        selectedFilters: {
          checkedPlatforms: [],
          checkedAssets: [],
          checkedRoles: [],
        },
        searchValue: '',
      };
    case UPDATE_SEARCH_VALUE:
      return {
        ...state,
        searchValue: action.payload,
      };
    case STORE_FILTER_API_RESPONSES:
      return {
        ...state,
        apiResponses: action.payload,
      };
    default:
      return state;
  }
};

export default landingPageFiltersReducer;
